export default __webpack_public_path__ + "static/media/ADEN-Acrópolis-QR-App-Store.5c37590f.png";